<template>
  <div class="home-video">
    <div class="video-header">
      <!-- 视频标题 -->
      <template v-if="categoryList.length > 0">
        <div v-if="categoryList.length > 1" class="section-title-wrapper">
          <span v-for="(item, idx) in categoryList" :key="idx" class="title-item">
            <a 
              v-if="item.templatePath" 
              :href="item.templatePath + '?categoryId=' + item.id" 
              target="_blank" 
            >
              {{ item.name }}
            </a>
            <span v-else>{{ item.name }}</span>
          </span>
        </div>
        <div v-else class="video-title-desc">
          <div class="video-title"> <a  class="video-title-link"
              v-if="categoryList[0].templatePath" 
              :href="categoryList[0].templatePath + '?categoryId=' + categoryList[0].id" 
              target="_blank"
            >{{ categoryList[0].name }} </a></div>
          <p class="video-desc">
            <span 
              class="summary-text"
              @click="goDetail(videoData)"
            >{{ videoData ? videoData.summary : '' }}</span>
          </p>
        </div>
      </template>
      <template v-else>
        <!-- 旧方式：根据配置决定是否渲染为链接 -->
        <template v-if="categoryList.length > 0">
          <a class="video-title-link" :href="categoryMap['视频'].templatePath + '?categoryId=' + categoryMap['视频'].id" target="_blank">
            <div class="video-title-desc">
              <div class="video-title">视频</div>
              <p class="video-desc">
                <span class="summary-text">{{ videoData ? videoData.summary : '' }}</span>
              </p>
            </div>
          </a>
        </template>
        <div v-else class="video-title-desc">
          <div class="video-title">视频</div>
          <p class="video-desc">
            <span 
              class="summary-text"
              @click="goDetail(videoData)"
            >{{ videoData ? videoData.summary : '' }}</span>
          </p>
        </div>
      </template>
      
      <div class="video-tabs">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="tab-item"
          :class="{ active: currentTabIndex === idx }"
          @click="openChannelPage(tab)"
        >· {{ tab.name }} ·</div>
      </div>
      <div class="video-arrows">
        <img :src="arrowLeft" @click="prevTab" />
        <img :src="arrowRight" @click="nextTab" />
      </div>
    </div>
    <div class="video-body">
      <div class="video-main" :style="videoMainStyle" @click="goDetail(videoData)">
        <span class="activity-label">活动</span>
        <div class="video-main-title">{{ videoData ? videoData.title : '' }}</div>
      </div>
      <div class="video-side">
        <div class="side-cards">
          <a v-for="(card, idx) in sideCards" :key="idx" class="side-card" :href="getLink(card)" target="_blank" :style="getSideCardStyle(card)">
            <span class="interview-label">{{ currentTab.label }}</span>
            <div class="side-card-title">{{ card.title }}</div>
          </a>
        </div>
        <div class="side-list">
          <a v-for="(item, idx) in sideList" :key="idx" :href="getLink(item)" target="_blank">{{ item.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'HomeVideo',
  data() {
    return {
      currentTabIndex: 0,
      videoData: null,
      tabCache: {},
      categoryList: [],
      newsList: [],
      tabs: [
        { name: '专题', label: '专题', positionKey: 'index_video_right_1' },
        { name: '人物', label: '人物', positionKey: 'index_video_right_2' },
        { name: '案例', label: '案例', positionKey: 'index_video_right_3' }
      ],
      arrowLeft: require('../img/FigmaDDSSlicePNG126b41758b2d4faecf4554f21f1965c8.png'),
      arrowRight: require('../img/FigmaDDSSlicePNG726172a8dbbf1a2fec513f3fe3a5414b.png')
    }
  },
  computed: {
    currentTab() {
      return this.tabs[this.currentTabIndex]
    },
    // 过滤当前 tab 的数据
    filteredCurrentTabData() {
      return this.tabCache[this.currentTabIndex] || []
    },
    currentTabData() {
      return this.filteredCurrentTabData
    },
    sideCards() {
      return this.currentTabData.slice(0, 2)
    },
    sideList() {
      return this.currentTabData.slice(2, 5)
    },
    videoMainStyle() {
      const url = this.getImageUrl(this.videoData)
      if (url) {
        return {
          backgroundImage: `url(${url})`
        }
      }
      return {}
    }
  },
  created() {
    this.loadVideoData()
    this.loadCurrentTabData(0)  // 添加这一行，确保默认 tab 数据已加载
    this.loadCurrentTabData(1)
    this.loadCurrentTabData(2)
  },
  methods: {
    async loadVideoData() {
      try {
        // 加载主视频内容
        const res = await request.post('/api/index/getIndexRecommendInfo', { positionKey: 'index_video' })
        if (res.code === 200 && res.data) {
          this.categoryList = res.data.categoryList || []
          this.newsList = res.data.newsList || []
          
          // 只设置 videoData，不设置 tabCache[0]
          this.videoData = this.newsList[0]
        }
      } catch (e) {
        console.error('视频数据加载失败', e)
      }
    },
    async loadCurrentTabData(index) {
      // 如果当前 tab 已经有数据，说明已加载过
      if (this.tabCache[index] && this.tabCache[index].length > 0) return
      
      try {
        // 使用新接口加载当前 tab 的数据
        const res = await request.post('/api/index/getIndexRecommendInfo', { 
          positionKey: this.tabs[index].positionKey 
        })
        if (res.code === 200 && res.data && res.data.newsList) {
          this.$set(this.tabCache, index, res.data.newsList.slice(0, 5))
          this.tabs[index].name = res.data.categoryList[0].name
          this.tabs[index].label = res.data.categoryList[0].name
        }
      } catch (e) {
        console.error('tab 数据加载失败', e)
      }
    },
    switchTab(index) {
      if (index === this.currentTabIndex) return
      this.currentTabIndex = index
      this.loadCurrentTabData() // 加载数据，但不跳转页面
    },
    async openChannelPage(tab) {
      // 如果当前 tab 还没有 categoryId，需要先加载数据获取
      if (!tab.categoryId) {
        try {
          const res = await request.post('/api/index/getIndexRecommendInfo', { 
            positionKey: tab.positionKey 
          })
          if (res.code === 200 && res.data && res.data.categoryList && res.data.categoryList.length > 0) {
            tab.categoryId = res.data.categoryList[0].id
            tab.templatePath = res.data.categoryList[0].templatePath
          }
        } catch (e) {
          console.error('获取频道信息失败', e)
          return
        }
      }
      
      // 在新页面打开频道页面
      if (tab.templatePath && tab.categoryId) {
        window.open(`${tab.templatePath}?categoryId=${tab.categoryId}`, '_blank')
      }
    },
    nextTab() {
      this.switchTab((this.currentTabIndex + 1) % this.tabs.length)
    },
    prevTab() {
      this.switchTab((this.currentTabIndex - 1 + this.tabs.length) % this.tabs.length)
    },
    getLink(item) {
      if (item && item.newsCode) {
        return `/zp/a/${item.newsCode}`
      }
      return '#'
    },
    goDetail(item) {
      if (item && item.newsCode) {
        window.open(`/zp/a/${item.newsCode}`, '_blank')
      }
    },
    getSideCardStyle(card) {
      const url = this.getImageUrl(card)
      if (url) {
        return {
          backgroundImage: `url(${url})`
        }
      }
      return {}
    },
    getImageUrl(item) {
      if (!item) return ''
      return item.coverImage || item.imageUrl || item.cover || item.img || ''
    }
  }
}
</script>

<style scoped>
.home-video {
  width: 1400px;
  margin: 0 auto;
  padding-top: 37px;
  box-sizing: border-box;
  margin-top: 10px;
}
.video-header {
  width: 1395px;
  height: 167px;
  display: flex;
  margin-left: 2px;
}
.video-title-desc {
  width: 650px;
  height: 167px;
}
.video-title {
  width: 64px;
  height: 42px;
  color: rgba(185, 24, 22, 1);
  font-size: 32px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  white-space: nowrap;
  line-height: 32px;
}
.video-title a:hover {
  color: #C00513;
  text-decoration: underline;
}
.video-desc {
  width: 650px;
  height: 96px;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  line-height: 32px;
  margin: 29px 0 0 0;
  overflow: hidden;
  cursor: pointer;
}

.video-desc:hover .summary-text {
  color: rgba(185, 24, 22, 1);
}
.video-tabs {
  display: flex;
  gap: 30px;
  margin: 7px 0 0 25px;
}
.tab-item {
  width: 160px;
  height: 158px;
  background-color: rgba(245, 245, 247, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 1);
  font-size: 32px;
  font-family: 'Microsoft YaHei', sans-serif;
  white-space: nowrap;
  line-height: 32px;
  cursor: pointer;
  box-sizing: border-box;
}
.tab-item a:hover {
  color: #C00513;
  text-decoration: underline;
}
.tab-item.active {
  color: rgba(185, 24, 22, 1);
  border: 3px solid rgba(185, 24, 22, 1);
  background: url('../img/FigmaDDSSlicePNG8c29025b15c5d8f2c90cc2c4cb85369b.png') 100% no-repeat;
  background-size: 100% 100%;
}
.video-arrows {
  display: flex;
  gap: 22px;
  margin: 119px 0 0 66px;
  align-self: flex-start;
}
.video-arrows img {
  width: 46px;
  height: 46px;
  cursor: pointer;
}
.video-body {
  width: 1300px;
  height: 374px;
  display: flex;
  gap: 26px;
  margin: 32px 0 0 1px;
}
.video-main {
  width: 650px;
  height: 366px;
  background: url('../img/FigmaDDSSlicePNG3607d6ff9fad3214d55732ab50eb06a1.png') 100% no-repeat;
  background-size: 100% 100%;
  margin-top: 1px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.activity-label {
  width: 65px;
  height: 60px;
  background: url('../img/label-bg-activity.png') no-repeat;
  background-size: 100% 100%;
  color: #FFFFFF;
  font-size: 22px;
  font-family: 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-style: normal;
  text-transform: none;
  margin-left: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.video-main-title {
  width: 650px;
  height: 47px;
  background-color: rgba(0, 0, 0, 0.8);
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  line-height: 47px;
  padding-left: 22px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.video-side {
  width: 624px;
  height: 374px;
  display: flex;
  flex-direction: column;
}
.side-cards {
  width: 624px;
  height: 197px;
  display: flex;
  gap: 24px;
}
.side-card {
  width: 350px;
  height: 197px;
  display: block;
  text-decoration: none;
  background: url('../img/FigmaDDSSlicePNG19631465efea9ebfc671303207fc9a07.png') 100% no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.interview-label {
  width: 57px;
  height: 44px;
  background: url('../img/label-bg.png') no-repeat;
  background-size: 100% 100%;
  color: #FFFFFF;
  font-size: 16px;
  font-family: 'Microsoft YaHei', sans-serif;
  font-weight: 400;
  font-style: normal;
  text-transform: none;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-orientation: upright;
  letter-spacing: 2px;
  box-sizing: border-box;
}
.side-card-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 14px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #FFFFFF;
  font-size: 16px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}
.side-list {
  width: 724px;
  height: 158px;
  margin-top: 19px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.side-list a {
  width: 724px;
  height: 44px;
  color: rgba(0, 0, 0, 1);
  font-size: 22px;
  font-family: 'Microsoft YaHei', sans-serif;
  text-align: left;
  line-height: 44px;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.side-list a:hover {
  color: rgba(185, 24, 22, 1);
}

/* 视频标题链接 */
.video-title-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 167px;
}

.video-title-link:hover .video-title {
  color: #C00513;
  text-decoration: underline;
}

title-item {
  display: inline;
}

/* 链接文本 - inline 保证在一行 */
.section-title-wrapper a {
  display: inline;
  color: #B91816;
  font-size: 34px;
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 34px;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
}

.section-title-wrapper a:hover {
  color: #C00513;
  text-decoration: underline;
}

/* 分隔符：独立 span，不是超链接 */
.section-title-wrapper .title-separator {
  display: inline;
  color: #B91816;
  font-size: 34px;
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 34px;
  margin: 0 8px;       /* 左右间距一致 */
  cursor: default;     /* 默认光标，不显示手型 */
  user-select: none;   /* 不可选中 */
}
</style>
